import { useCallback, useEffect, useState, useRef } from 'react';
import useAgent from './useAgent';

const usePaginatedAgent = (agent) => {
  const [paginatedData, setPaginatedData] = useState();
  const lastFetchSize = useRef(null);

  const [fetchData, data, isFetchingData] = useAgent(agent);

  useEffect(() => {
    if (data) {
      // Track how many items were returned in this fetch
      lastFetchSize.current = data.length;
      setPaginatedData((oldData) => (oldData ? [...oldData, ...data] : data));
    }
  }, [data]);

  const call = useCallback(
    (...params) => {
      const callParams = params[params.length - 1];
      if (!callParams || !callParams.skip) {
        setPaginatedData(undefined);
        lastFetchSize.current = null;
      }
      return fetchData(...params);
    },
    [fetchData]
  );

  return [call, paginatedData, isFetchingData, lastFetchSize.current];
};

export default usePaginatedAgent;
